import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
import "../../../../../index.css";
class ToCollageToolFilterHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    const {
      totalScore,
      wholeSubject,
      subjectCondition,
      exportExcel,
      handleVisibleFilter,
      open
    } = this.props;
    return (
      <div className="to_college_tool_filter_header_header_big_box">
        <div className="to_college_tool_filter_header_header_box">
          <div className="fl to_college_tool_filter_header_header_sl_box">
            <div>
              选科：{wholeSubject[subjectCondition[0]]}{" "}
              {wholeSubject[subjectCondition[1]]}{" "}
              {wholeSubject[subjectCondition[2]]}
            </div>
            <div>
              总分：
              <span>{totalScore}</span>
            </div>
          </div>
          <div onClick={handleVisibleFilter} className="fr to_college_tool_filter_header_info_box">
            <img
              alt=""
              src={require("../../../../../images/tocollege/filter.png")}
            ></img>
            <div  className="fl ">
              筛选
            </div>
          </div>
        </div>
        <div className="to_college_tool_filter_header_download_box">
          <NavLink className="fl" to="/articledetail/6yBCb">
            <div className="fl">填报技巧</div>
            <img
              className="fl"
              alt=""
              src={require("../../../../../images/tocollege/skill.png")}
            ></img>
          </NavLink>
          {this.state.css.width > 750 ? (
            <div onClick={() => exportExcel()} className="fr" style={{cursor:'pointer'}}>
              <img
                className="fl"
                alt=""
                src={require("../../../../../images/tocollege/download.png")}
              ></img>
              <div className="fr">下载导出</div>
            </div>
          ) : (
            <div  onClick={() => open()}  className="fr" style={{cursor:'pointer'}}>
              <img
                className="fl"
                alt=""
                src={require("../../../../../images/tocollege/download.png")}
              ></img>
              <div className="fr">下载导出</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  fixCss = () => {
    let width = window.innerWidth;
    this.setState({
      css: {
        width: width,
      },
    });
  };
}

export default ToCollageToolFilterHeader;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollageToolFilter/components/ToCollageToolFilterHeader/index.js